import { Box, Button, HStack, Stack } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { CalendarSyncDirectionEnum } from "@src/__generated__/graphql";
import { ButtonLink, Select } from "@src/components/ui-kit";
import {
  GoogleCalendarIcon,
  OutlookCalendarIcon,
} from "@src/components/ui-kit/Icon";
import { API_BASE_URL } from "@src/config/constants";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";

export const CalendarIntegrations = observer(function CalendarIntegrations() {
  const { editUserModalStore: store } = useStore();

  if (store.calendarIntegrationEnabled) {
    return (
      <Stack spacing="4">
        <Select
          options={store.calendarSyncDirectionOptions}
          label={t`Calendar sync direction`}
          value={store.form.calendar_sync_direction.value}
          onChange={store.form.calendar_sync_direction.onChange}
        />
        {store.form.calendar_sync_direction.value !==
          CalendarSyncDirectionEnum.FromCalendar && (
          <Select
            options={store.calendarSyncAllocationTypesOptions}
            label={t`Calendar sync allocation types`}
            isMulti
            value={store.form.calendar_sync_allocation_types.value}
            onChange={store.form.calendar_sync_allocation_types.onChange}
          />
        )}
        <HStack justify="end" w="full">
          <Button
            colorScheme="red"
            isLoading={store.isCalendarDisabling}
            onClick={store.disconnectCalendarIntegration}
          >
            <Trans>Disconnect</Trans>
          </Button>
        </HStack>
      </Stack>
    );
  }

  return (
    <HStack>
      <Trans>Enable</Trans>
      <Box>
        <ButtonLink
          aria-label={t`Google Calendar`}
          colorScheme="grey"
          leftIcon={<GoogleCalendarIcon />}
          variant="outline"
          href={`${API_BASE_URL}/google-calendar/auth`}
          isExternal
          size="xs"
          target="_self"
        >
          <Trans>Google</Trans>
        </ButtonLink>
      </Box>
      <Trans>or</Trans>
      <Box>
        <ButtonLink
          aria-label={t`Outlook Calendar`}
          colorScheme="messenger"
          href={`${API_BASE_URL}/outlook-calendar/auth`}
          isExternal
          leftIcon={<OutlookCalendarIcon />}
          variant="outline"
          size="xs"
          target="_self"
        >
          <Trans>Outlook</Trans>
        </ButtonLink>
      </Box>
      <Trans>calendar integration.</Trans>
    </HStack>
  );
});
